'use client';
import { px } from '../units-converters/px.mjs';

function getBreakpointValue(breakpoint, theme) {
  if (breakpoint in theme.breakpoints) {
    return px(theme.breakpoints[breakpoint]);
  }
  return px(breakpoint);
}

export { getBreakpointValue };
//# sourceMappingURL=get-breakpoint-value.mjs.map
